import { UserPageMutations, } from './types';
const mutations = {
    [UserPageMutations.SET_PAGE_TYPE](state, type) {
        state.type = type;
    },
    [UserPageMutations.RESET_USER_DETAIL](state) {
        state.userDetail = '';
    },
    [UserPageMutations.GET_USER_DETAIL](state, payload) {
        state.userDetail = payload;
    },
    [UserPageMutations.GET_HUB_LIST](state, payload) {
        state.hubList = payload;
    },
};
export default mutations;
